import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

import PickedShipmentInfo from 'components/add_order/picklist/ProcessPicklist/PickedShipmentInfo';
import PickedShipmentTable from 'components/add_order/picklist/ProcessPicklist/PickedShipmentTable';

const PickedShipment = ({
  picklistId,
  shipmentData,
  onRefresh,
  onPicklistUpdate,
}) => {
  const handleRefresh = async () => {
    await onRefresh();
    onPicklistUpdate();
  };

  return (
    <Row>
      <Col md={3} className="mb-3 mb-md-0">
        <PickedShipmentInfo
          picklistId={picklistId}
          shipmentData={shipmentData}
          onRefresh={handleRefresh}
        />
      </Col>

      <Col md={9}>
        <Card>
          <Card.Header className="bg-light">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5 className="mb-0">SHIPMENT ITEMS</h5>
              </div>
            </div>
          </Card.Header>
          <Card.Body className="p-0">
            <PickedShipmentTable shipmentData={shipmentData} />
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default PickedShipment;
